(() => {
  if (!customElements.get('sc-compare')) {
    customElements.define('sc-compare', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        const range = this.parentElement.querySelector('[data-sc-compare-range]');
        const set = value => {
          const percentage = Math.max(0, Math.min(100, Number(value)));
          this.style.setProperty('--split', `${percentage}%`);
          range.value = Math.round(percentage);
          range.setAttribute('aria-valuetext', `${Math.round(percentage)}% before, ${100 - Math.round(percentage)}% after`);
        };
        const move = event => {
          const rect = this.getBoundingClientRect();
          if (rect.width) set((event.clientX - rect.left) / rect.width * 100);
        };
        range.addEventListener('input', () => set(range.value));
        this.addEventListener('pointerdown', event => {
          if (event.button !== 0) return;
          this.dragging = event.pointerId;
          this.setPointerCapture(event.pointerId);
          move(event);
        });
        this.addEventListener('pointermove', event => { if (this.dragging === event.pointerId) move(event); });
        ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(name => this.addEventListener(name, () => { this.dragging = null; }));
      }
    });
  }

  function newsletter(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const dialog = root.querySelector('[data-sc-welcome]');
    // No emails or identifiers are kept in browser storage.
    const storageKey = 'sc-welcome-v1';
    const read = () => { try { return JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch { return {}; } };
    const save = value => { try { localStorage.setItem(storageKey, JSON.stringify(value)); } catch { /* Signup works even when storage is blocked. */ } };
    const success = root.querySelector('[data-sc-newsletter-success]');
    const error = root.querySelector('[data-sc-newsletter-error]');
    const returningToPopup = location.hash === '#ScNewsletterPopup';
    const subscribed = root.dataset.subscribed === 'true' || !!success || read().subscribed;
    if (subscribed) save({ subscribed: true });
    if (!dialog || typeof dialog.showModal !== 'function') return;
    let previousFocus;
    let timer;
    const open = () => {
      if (!root.isConnected || dialog.open) return;
      previousFocus = document.activeElement;
      dialog.showModal();
      document.documentElement.classList.add('sc-welcome-open');
    };
    const close = () => dialog.close();
    dialog.querySelectorAll('[data-sc-welcome-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); } });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('sc-welcome-open');
      clearTimeout(timer);
      if (!subscribed) save({ dismissedUntil: Date.now() + Number(dialog.dataset.dismissDays || 30) * 86400000 });
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    });
    if (returningToPopup && (success || error)) { open(); return; }
    if (subscribed || read().dismissedUntil > Date.now() || window.Shopify?.designMode) return;
    const attempt = () => {
      if (!root.isConnected) return;
      // Don't interrupt typing, a mobile menu, or a video demonstration.
      const busy = document.hidden || document.activeElement?.matches('input,textarea,select,[contenteditable="true"]') || document.querySelector('dialog[open], [data-scshell-burger][aria-expanded="true"]') || [...document.querySelectorAll('video')].some(video => !video.paused);
      if (busy) { timer = setTimeout(attempt, 1500); return; }
      open();
    };
    timer = setTimeout(attempt, Math.max(0, Number(dialog.dataset.delay || 10)) * 1000);
    addEventListener('pagehide', () => clearTimeout(timer), { once: true });
  }
  const init = () => document.querySelectorAll('[data-sc-newsletter]').forEach(newsletter);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
